<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$lang('谷歌验证码解绑')"
    top="10vh"
    width="480px"
    @close="close"
    :visible.sync="visible"
    >
    <main class="unbind_main">
      <div class="header_title">
        <span>{{$lang('您在系统中绑定的手机号码是：')}}</span>
        <span>{{ tuominPas }}, </span>
        <span>{{ $lang('请输入验证码进行解绑') }}</span>
      </div>
      <el-form :model="form" label-position="top">
        <el-form-item :label="$lang('短信验证码')" required>
          <el-input
            v-model="form.code"
            placeholder="请输入验证码"
            maxlength="6"
            class="code_input"
          >
          <section slot="suffix" class="send_code">
            <p v-show="!btnTimeShow" @click="sendCode">{{ $lang(verifyText) }}</p>
            <p v-show="btnTimeShow">{{ time }}s</p>
          </section>
        </el-input>
        </el-form-item>
      </el-form>
    </main>
    <footer slot="footer">
      <el-button @click="close">{{ $lang('取消') }}</el-button>
      <el-button type="primary" :loading="btnLoading" @click="unbind">{{ $lang('确定') }}</el-button>
    </footer>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import verification from '@/mixins/sliderVerification.js'
import * as Api from '@api/base/public'

export default {
  components: {},
  mixins: [verification],
  props: {
    visible: {
      type: Boolean,
      default: false
    }

  },
  name: 'UnbindDialog',
  data() {
    return {
      btnTimeShow: false,
      time: 60,
      verifyText: '发送验证码',
      form: {
        code: ''
      },
      interVal: null,
      btnLoading: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.base.user
    }),
    tuominPas() {
      return this.user.contactMobile.replace(/^(.{3})(?:\d+)(.{4})$/, '$1****$2')
    }
  },
  watch: {},
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    sendCode() {
      this.captcha.show()
    },
    async submitForm(customParams) {
      const params = {
        ...customParams,
        mobile: this.user.contactMobile
      }
      const { code, msg } = await Api.getCodeUpdatePwd(params)
      if (code === 1) {
        clearInterval(this.interVal)
        this.interVal = setInterval(() => {
          this.time--
          this.btnTimeShow = true
          if (this.time === 0) {
            this.time = 60
            this.verifyText = '重新发送'
            this.btnTimeShow = false
            clearInterval(this.interVal)
          }
        }, 1000)
      } else {
        this.$message.error(msg)
      }
    },
    async unbind() {
      this.btnLoading = true
      const { code, msg } = await Api.unbindGoogle({ verifyCode: this.form.code })
      this.btnLoading = false
      if (code === 1) {
        this.close()
        this.$emit('unbind')
        this.$message.success(this.$lang('解绑成功'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang='scss'>
 /* @import url(); 引入css类 */
::v-deep{
   .el-dialog .el-dialog__body {
      padding: 10px 20px !important;
  }
  .el-form-item__label{
    font-weight: 600;
    color:#000;
  }
  .el-input__suffix{
    line-height: 24px;
  }
  .el-dialog__footer{
    border-top: none;
  }
  .el-form-item__label{
    padding: 0;
  }

}
.header_title{
  margin: 5px 0px 20px;
  line-height: 19px;
}
.code_input{
  width: 100%;
}
.send_code{
  background-color: #ff1a2c;
  border-radius: 6px;
  margin-top: 4px;
  cursor: pointer;
  p{
    margin: 0;
    color: #E4E4E4;
    font-size: 12px;
    font-weight: 400;
    padding: 0 5px;
    min-width: 50px;
  }
}
</style>
